import { Box, Stack } from "@mui/material";
// Placeholder illustration — reuses the positive-sentiment mood asset until a
// dedicated thank-you SVG lands (ALCH-6720). Single import, swap in one place.
import AppreciationIllustration from "@src/appV2/redesign/assets/icons-colored/rating-prompt-mood.svg?react";
import { Button } from "@src/appV2/redesign/components/Button";
import { Dialog } from "@src/appV2/redesign/components/Dialog";
import { Text } from "@src/appV2/redesign/components/Text";
import { type UseModalState } from "@src/lib/ui-react";

export interface ReviewPromptAppreciationStepProps {
  modalState: UseModalState;
  title: string;
  body: string;
  doneText: string;
  /** Fired on Done, backdrop click, and Escape — all route to the same close. */
  onClose: () => void | Promise<void>;
}

export function ReviewPromptAppreciationStep(props: ReviewPromptAppreciationStepProps) {
  const { modalState, title, body, doneText, onClose } = props;

  return (
    <Dialog
      modalState={modalState}
      showCloseButton={false}
      width={360}
      onClose={async () => {
        await onClose();
      }}
    >
      <Stack alignItems="center" spacing={3}>
        <Box
          sx={(theme) => ({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            paddingTop: theme.spacing(2),
            "& > svg": {
              maxWidth: "160px",
              height: "auto",
            },
          })}
        >
          <AppreciationIllustration aria-hidden="true" />
        </Box>

        <Stack alignItems="center" spacing={1}>
          <Text
            semibold
            variant="h5"
            sx={(theme) => ({
              color: theme.palette.base?.strong ?? theme.palette.text.primary,
              textAlign: "center",
              wordBreak: "break-word",
              textWrap: "balance",
            })}
          >
            {title}
          </Text>
          <Text
            variant="body2"
            sx={(theme) => ({
              color: theme.palette.base?.base ?? theme.palette.text.secondary,
              textAlign: "center",
              wordBreak: "break-word",
            })}
          >
            {body}
          </Text>
        </Stack>

        <Stack spacing={2} sx={{ width: "100%" }}>
          <Button
            fullWidth
            variant="primary"
            onClick={async () => {
              await onClose();
            }}
          >
            {doneText}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
}
